<app-page-heading [key]="'administration.cico-help-configuration.page-title'"></app-page-heading>

<div class="container summary-panel space-top-20">
    <div class="ibox cico-help">
        <div class="ibox-content">
            <div class="current-help-file">
                <div class="current-help-file-label" [i18n]="'administration.cico-help-configuration.current-file'"></div>
                <div class="current-help-file-wrapper">
                    <span class="noImage" *ngIf="!currentFile">
                        <img src="assets/no-image.svg" width="54">
                        No image
                    </span>
                    <img *ngIf="currentFile && ['image/png', 'image/jpeg'].includes(currentFileType)" class="current-help-file-wrapper-img"
                         [src]="currentFile.downloadUrl | resourceSecureUrl" alt="document">
                </div>
            </div>

            <div class="upload-file">
                <div class="upload-file-label" [i18n]="'administration.cico-help-configuration.upload'"></div>
                <app-file-upload class="upload-file-drag-drop"
                                 [acceptedFileTypes]="acceptedFileTypes"
                                 [acceptedFileExtensions]="acceptedFileExtensions"
                                 [labelKey]="'administration.cico-help-configuration.select-document'"
                                 [disabled]="!!pendingFile"
                                 (onFileAdded)="pendingFile=$event">
                </app-file-upload>
                <span class="upload-file-help" [i18n]="'administration.cico-help-configuration.file-format'"></span>
                <div class="upload-file-pending" *ngIf="pendingFile">
                    <span class="upload-file-pending-filename">{{pendingFile.name}}</span>
                    <div class="upload-file-pending-actions">
                        <button class="btn btn-danger upload-file-actions-cancel"
                                [i18n]="'administration.cico-help-configuration.cancel'"
                                (click)="resetPendingFile()">
                        </button>
                        <button class="btn btn-primary upload-file-actions-validate"
                                [i18n]="'administration.cico-help-configuration.validate'"
                                (click)="uploadFile()">
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>


